module.exports = __webpack_public_path__ + "media/images/features/easy_and_intuitive_img-b270d233215a76bc28f54c48471038bb.png";